import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";
import { toast } from 'react-toastify';
import { setUserPassword } from "../../APIs/UserRequests";

export default function SetPasswordPage() {

    // get query params
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    const { t } = useContext(TranslatorContext);

    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const setUserPasswordAction = () => {
        if (password !== confirmPassword) {
            const notify = () => toast.error(t('passwords_do_not_match'));
            notify();
            return;
        }
        if (password.length < 8) {
            const notify = () => toast.error(t('password_must_be_at_least_8_characters'));
            notify();
            return;
        }
        setLoading(true);
        setUserPassword(token,password).then((res) => {
            if (res.status === 200) {
                const notify = () => toast.success(res.data.message);
                notify();
                window.location.href = '/login';
            } else {
                const notify = () => toast.error(t('error_setting_password'));
                notify();
            }
        }).catch((err) => {
            const notify = () => toast.error(t('error_setting_password'));
            notify();
        }).finally(() => {
            setLoading(false);
        });
    }
    return (
        <div className="mc-auth">
            <img 
                className="mc-auth-pattern" 
                src="images/pattern.webp"
                alt="pattern"
            />
            <div className="mc-auth-group">
                <LogoComponent 
                    src="images/logo.webp"
                    alt="logo" 
                    href="/"
                    className="mc-auth-logo"
                />
                <h4 className="mc-auth-title">{t('set_password')}</h4>
                <form className="mc-auth-form">
                    <IconFieldComponent 
                        icon="lock"
                        type="password"
                        classes="h-sm"
                        placeholder={t('enter_your_password')}
                        value={password}
                        passwordVisible={true}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <IconFieldComponent 
                        icon="lock"
                        type="password"
                        classes="h-sm"
                        placeholder={t('confirm_your_password')}
                        value={confirmPassword}
                        passwordVisible={true}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />

                    <ButtonComponent className="mc-auth-btn h-sm" type="button"
                        onClick={setUserPasswordAction}
                        color="primary"
                        size="sm"
                        classes="w-100 h-sm"
                        loading={loading}
                    >
                        {t('set_password')}
                    </ButtonComponent>
                </form>
                
            </div>
        </div>
    );
}